import React, { Component } from 'react';
import moment from 'moment';
import { baseApiUrl } from '../../api/ApiHelpers';
import { ButtonExport } from '../common/buttons';
import { humanize } from '../../utils/helpers/text_formatters';

export default class ExportCSVButton extends Component {
  handleExportCSVButtonClick = () => {
    const perPage = 5000000; // Set this to control maximum amount of records allowed in a CSV, anything greater will cause error for Ads from Elasticsearch
    const jwt = localStorage.getItem('jwt');
    const { resourceName, filters, start_date, end_date, group_by, sort } = this.props;

    let url = '';
    let csvName = '';

    // Build the correct API URL for GET request depending on what route the user is on when requesting CSV
    switch (resourceName) {
      case 'advertiserReport':
      case 'publisherReport': {
        const pathName = resourceName === 'advertiserReport' ? 'advertiser' : 'publisher';
        const groupByString = ['publisher', 'advertiser'].includes(group_by) ? '' : group_by.charAt(0).toUpperCase() + group_by.slice(1);
        let paramsString = '';

        csvName = `${pathName.charAt(0).toUpperCase() + pathName.slice(1)} ${groupByString} Report`;
        url = `${baseApiUrl}/v1/admin/${pathName}/reports.csv?`;

        // Iterate through filters and create params string to put into the URL
        Object.entries(filters).forEach(([field, values]) => {
          Object.entries(values).forEach(([key, value]) => {
            paramsString += `filters%5B${field}%5D%5B${key}%5D=${value}&`;
          });
        });

        paramsString += `csv=true&per_page=${perPage}&page=1&start_date=${start_date}&end_date=${end_date}&group_by=${group_by}`;
        url += paramsString;

        break;
      }
      case 'connectionReports': {
        let paramsString = '';
        url = `${baseApiUrl}/v1/admin/connection_reports.csv?`;
        csvName = humanize(resourceName);

        paramsString += `csv=true&per_page=${perPage}&page=1&`;

        // Iterate through filters and create params string to put into the URL
        Object.entries(filters).forEach(([field, values]) => {
          Object.entries(values).forEach(([key, value]) => {
            if (Array.isArray(value)) {
              const arrayToParams = value.map(v => `filters%5B${field}%5Dvalue%5B%5D%5Bvalue%5D=${v?.value}`).join('&');
              paramsString += arrayToParams;
            } else {
              paramsString += `filters%5B${field}%5D%5B${key}%5D=${value}&`;
            }
          });
        });

        if (sort && Object.keys(sort).length && sort.constructor === Object) {
          paramsString += Object.keys(sort)
            .map(key => `sort%5B${key}%5D=${sort[key]}&`)
            .join('');
        }

        url += paramsString;
        break;
      }
      default: {
        let paramsString = '';
        csvName = humanize(resourceName);

        if (resourceName === 'salesRep') {
          url = `${baseApiUrl}/v1/admin/sales_reps.csv?`;
        } else if (resourceName === 'emailAlertCampaign') {
          url = `${baseApiUrl}/v1/admin/email_alert/campaigns.csv?`;
        } else {
          url = `${baseApiUrl}/v1/admin/${resourceName}${resourceName[-1] === 's' ? '' : 's'}.csv?`;
        }

        paramsString += `csv=true&per_page=${perPage}&page=1&`;

        // Iterate through filters and create params string to put into the URL
        Object.entries(filters).forEach(([field, values]) => {
          if (field === 'start_date' || field === 'end_date') {
            paramsString += `filters%5B${field}%5D=${values}&`;
          } else {
            Object.entries(values).forEach(([key, value]) => {
              if (Array.isArray(value)) {
                const arrayToParams = value.map(i => `value[]=${i}&`).join();
                paramsString += `filters%5B${field}%5D${arrayToParams}`;
              } else {
                paramsString += `filters%5B${field}%5D%5B${key}%5D=${value}&`;
              }
            });
          }
        });

        if (sort && Object.keys(sort).length && sort.constructor === Object) {
          paramsString += Object.keys(sort)
            .map(key => `sort%5B${key}%5D=${sort[key]}&`)
            .join('');
        }

        url += paramsString;

        break;
      }
    }

    // Can use below code to access filter values built into bootstrap table
    // console.log(this.refs.websitesTable.filter.currentFilter);

    // Make API call to fetch records in CSV format
    fetch(url, {
      headers: {
        Authorization: `Bearer ${jwt.slice(1, -1)}`,
      },
    }).then(res => {
      if (res.status === 200) {
        res.text().then(csvString => {
          const csvContent = `data:text/csv;charset=utf-8,${csvString}`;
          const encodedUri = encodeURI(csvContent);
          const link = document.createElement('a');
          link.setAttribute('href', encodedUri);
          link.setAttribute('download', `${csvName} - ${moment().format('LLL')}.csv`);
          document.body.appendChild(link);
          link.click();
        });
      } else {
        console.log('Error, failed to connect to server');
      }
    });
  };

  render() {
    const visible = this.props.visible === undefined ? true : this.props.visible;

    return <div>{visible && <ButtonExport className="m-b-sm" btnLabel="Export to CSV" onClick={() => this.handleExportCSVButtonClick()} />}</div>;
  }
}
